var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocumentDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 5.865c.258 0 .467.209.467.466v3.593l.882-.822a.467.467 0 0 1 .637.682l-1.667 1.555a.467.467 0 0 1-.637 0L6.016 9.784a.467.467 0 0 1 .636-.682l.882.822V6.33c0-.257.209-.466.467-.466"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.113 1.531a1 1 0 0 1 .707.293l3.021 3.021a1 1 0 0 1 .293.707v7.513a1.4 1.4 0 0 1-1.4 1.4H4.268a1.4 1.4 0 0 1-1.4-1.4V2.932a1.4 1.4 0 0 1 1.4-1.4zm-4.845.934a.467.467 0 0 0-.467.467v10.133c0 .257.209.466.467.466h7.466c.258 0 .466-.209.466-.466V5.798H10a1.134 1.134 0 0 1-1.133-1.133v-2.2zm5.533 2.2c0 .11.09.2.2.2h1.54L9.8 3.125z",
  clipRule: "evenodd"
})));
export default SvgDocumentDown;